<template>
    <router-link :to="{ name: 'interim', params: { id: interim.id } }"
                 class="flex items-center shadow bg-white rounded py-12 px-24 cursor-pointer border border-white hover:border-primary-20 trans-ease"
                 @mousedown="currentInterim = interim"
    >
        <div class="w-1/6 flex items-center border-r border-primary-20 pr-16 h-48 overflow-hidden">
            <div class="draggable cursor-move">
                <svg-icon type="drag-indicator" />
            </div>
            <img
                :alt="interim.name"
                :src="interim.logo"
                class="grow h-full object-contain"
            >
        </div>
        <div class="grow pl-16 flex items-center justify-between gap-16 py-8">
            <p class="font-semibold text-body">{{ interim.name }}</p>
            <div v-if="matrixForInterim(interim).length > 0" @click.prevent>
                <simple-dropdown
                    :container="false"
                    width="auto"
                    @opened="trackMatrixView"
                >
                    <template #trigger>
                        <simple-button
                            icon="keyboard-arrow-down"
                            small
                        >
                            {{ $t('interims.open_matrix') }}
                        </simple-button>
                    </template>
                    <template #content>
                        <div class="max-w-920 overflow-x-auto bg-white rounded shadow relative flex">
                            <div
                                class="flex-1 text-center odd:bg-primary-5"
                                :key="value.id"
                                v-for="value in matrixForInterim(interim)"
                            >
                                <div class="p-8 whitespace-nowrap">
                                    {{ value.name }}
                                </div>
                                <div class="p-8 pt-0 font-semibold">
                                    {{ value.value }}
                                </div>
                            </div>
                        </div>
                    </template>
                </simple-dropdown>
            </div>
        </div>
        <div class="pl-16 flex items-center justify-end gap-8 class=text-white">
            <tooltip offset="0,16">
                <template #default>
                    <svg-icon
                        v-if="interim.linked || interim.connect_mail"
                        :class="[interim.linked ? 'text-secondary' : 'text-semantic-warning']"
                        class="max-w-16 max-h-16"
                        type="link"
                    />
                    <svg-icon
                        v-else
                        class="max-w-16 max-h-16 text-primary-20"
                        type="link-off"
                    />
                </template>
                <template #tooltip>
                    <div class="max-w-240 whitespace-normal">
                        <p class="text-white" v-if="interim.linked" v-html="$t('interims.connection_status.connected', {interim: interim.name})"></p>
                        <p class="text-white" v-else-if="interim.connect_mail" v-html="$t('interims.connection_status.pending', {interim: interim.name, mail: interim.connect_mail})"></p>
                        <p class="text-white" v-else v-html="$t('interims.connection_status.disconnected', {interim: interim.name})"></p>
                    </div>
                </template>
            </tooltip>
            <div
                class="pointer-events-auto"
                @click.prevent
            >
                <simple-dropdown
                    v-if="can.manage"
                    position="right"
                >
                    <template #trigger>
                        <button role="button" class="py-8">
                            <svg-icon class="w-20 h-20 text-primary-80 group-hover:text-primary" type="more-horiz"/>
                        </button>
                    </template>
                    <template #content="{ close }">
                        <nav
                            aria-orientation="vertical"
                            class="bg-white relative shadow rounded"
                            role="menu"
                        >
                            <dropdown-item
                                icon="edit"
                                :input-label="$t('general.edit')"
                                @click="close(); startEditingInterim(interim)"
                            />
                            <dropdown-item
                                danger
                                icon="delete"
                                :input-label="$t('general.delete')"
                                @click="close(); startDeletingInterim(interim)"
                            />
                        </nav>
                    </template>
                </simple-dropdown>
            </div>
        </div>
    </router-link>
</template>

<script>
import SvgIcon from './ui/SvgIcon';
import Tooltip from './navigation/Tooltip';
import SimpleDropdown from './ui/SimpleDropdown';
import { trackMatrixView } from '../etc/trackers';
import DropdownItem from "./ui/DropdownItem.vue";
import SimpleButton from "./ui/SimpleButton.vue";

export default {
    components: {SimpleButton, DropdownItem, SimpleDropdown, Tooltip, SvgIcon},
    props: {
        interim: null,
    },
    data() {
        return {};
    },
    computed: {
        can() {
            return {
                view: this.$can('interims.view'),
                manage: this.$can('interims.manage'),
            };
        },
    },
    methods: {
        startEditingInterim(interim) {
            this.$emit('edit', interim);
        },
        startDeletingInterim(interim) {
            this.$emit('delete', interim);
        },
        matrixForInterim(interim) {
            const matrixValues = JSON.parse(JSON.stringify(interim)).matrixValues.sort((a, b) => a.type.order - b.type.order);
            return matrixValues.filter(f => f.type).map(value => ({
                id: value.id,
                name: value.type.name,
                value: value.value,
            }));
        },
        trackMatrixView,
    },
};
</script>
